import React, { useContext, useEffect, useState } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { Close, Warning } from "@mui/icons-material";
import "./DuplicateNotification.css";

const DuplicateNotification = (props) => {

    const { data = {}, duplicateDocumentView, saveAllData } = useContext(DocumentDetailContext);

    const openDuplicate = (id) => {
        window.open(window.location.origin + window.location.pathname + "?doc_id=" + id + "&duplicate=true")
    }

    return data.Notifications?.Duplicate_Document_IDs?.split(
        ","
    )?.length ? <div className="warning_msg">
        <div>
            <Warning />
            <div className="msg-content">
                <div>This document could be a probable duplicate of &nbsp;</div>
                {data.Notifications?.Duplicate_Document_IDs?.split(
                    ","
                ).map((item, index) => (
                    <div className={!duplicateDocumentView ? "showLink" : ""} onClick={e => !duplicateDocumentView && openDuplicate(item)}>
                        {`${item}${data.Notifications?.Duplicate_Document_IDs?.split(",").length - 1 !== index ? ',' : ''}`}
                    </div>
                ))}
            </div>
        </div>
        {!duplicateDocumentView ? <Close onClick={() => saveAllData("duplicate")}/> : null}
    </div> : null
}

export default DuplicateNotification;